var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGpsAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF32AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "only-white",
    d: "M15.998 7.84766C12.7266 7.84766 9.99805 10.4274 9.99805 13.7213C9.99805 14.9744 10.3827 16.0918 11.1209 17.1389L15.5389 23.8876C15.7532 24.2156 16.2433 24.215 16.4572 23.8876L20.8943 17.116C21.6167 16.1163 21.998 14.9426 21.998 13.7213C21.998 10.4826 19.3064 7.84766 15.998 7.84766ZM15.998 16.3911C14.4943 16.3911 13.2708 15.1934 13.2708 13.7213C13.2708 12.2492 14.4943 11.0515 15.998 11.0515C17.5018 11.0515 18.7253 12.2492 18.7253 13.7213C18.7253 15.1934 17.5018 16.3911 15.998 16.3911Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsAlert);
export default __webpack_public_path__ + "static/media/gps-alert.23a5a4f3.svg";
export { ForwardRef as ReactComponent };